import React from 'react';

import Button from '../../../../library/button/button';
import Typography from '../../../../library/typography/typography';
import { CheckCircleSolidIcon } from '../../../../shared/icons/icons';
import {
  PACKAGE_STATUS,
  STEP_TYPE
} from '../../tire-wheel-package-status-constants';

import './tire-wheel-package-status-item.scss';

interface TireWheelPackageStatusItemProps {
  count: number;
  onChangeProductInBundle?: () => void;
  status: string;
  type: string;
}

function TireWheelPackageStatusItem(props: TireWheelPackageStatusItemProps) {
  const { count, onChangeProductInBundle, status, type } = props;

  const statusItemConfig = {
    [STEP_TYPE.TIRES]: {
      styleNames: {
        COMPLETED: 'completed',
        IN_PROGRESS: 'active',
        NOT_STARTED: 'inactive'
      },
      text: 'Choose Tires'
    },
    [STEP_TYPE.WHEELS]: {
      styleNames: {
        COMPLETED: 'completed',
        IN_PROGRESS: 'active',
        NOT_STARTED: 'inactive'
      },
      text: 'Choose Wheels'
    },
    [STEP_TYPE.FINALIZE]: {
      styleNames: {
        COMPLETED: 'completed',
        IN_PROGRESS: 'active',
        NOT_STARTED: 'inactive'
      },
      text: 'Package Completed'
    }
  };

  if (!statusItemConfig[type]) {
    return null;
  }

  return (
    <Button
      className="tire-wheel-package-status-item"
      isDisabled={
        status === PACKAGE_STATUS.NOT_STARTED ||
        status === PACKAGE_STATUS.IN_PROGRESS
      }
      onClick={onChangeProductInBundle}
      styleName="container"
    >
      <div styleName="icon-container">
        {status === PACKAGE_STATUS.COMPLETED ? (
          <CheckCircleSolidIcon styleName="completed-icon" />
        ) : (
          <Typography
            styleName={`${statusItemConfig[type].styleNames[status]}-step`}
            tag="span"
            weight="black"
          >
            {count}
          </Typography>
        )}
      </div>
      <Typography
        className={`tire-wheel-package-status-item__${statusItemConfig[type].styleNames[status]}-status`}
        styleName={`${statusItemConfig[type].styleNames[status]}-status`}
        tag="span"
        weight={status === PACKAGE_STATUS.IN_PROGRESS ? 'black' : 'normal'}
      >
        {statusItemConfig[type].text}
      </Typography>
    </Button>
  );
}

export default TireWheelPackageStatusItem;
